module.exports = __webpack_public_path__ + "media/images/application/template/search-a022de1d13f13066261315f4f86d92a8.svg";